var ctOutgoingMessagesModel;
(function ($) {
 	$.fn.capitechOutgoingMessages = function() {
		var $ctOutgoingMessagesElm = $(this);
		var options = { 
			extend: {
				"{root}": function(outgoingMessages) {
					outgoingMessageTemplate = function (outgoingMessage) {
						if (outgoingMessage.status() == 'Created') {
							return 'createdOutgoingTemplate';
						} else {
							return 'defaultOutgoingTemplate';
						}
					};
					deleteOutgoingMessages = function (outgoingMessage) {
						var success = function success(data, textStatus, jqXHR) {
							// Hide loader
							loaderIndicator(false);
							if (data.success == true) {
								ctOutgoingMessagesModel.outgoingMessages.remove(outgoingMessage);
							} else {
								sweetAlert(getResource('app.informationTitle'), handleServerErrorMessage(data.displayErrorMessage), "error");
							}
						};
						var error = function error(jqXHR, textStatus, errorThrown) {
							// Hide loader
							loaderIndicator(false);
							sweetAlert("Error", errorThrown, "error");
						};
						sweetAlert({
							title: getResource('app.confirmDeletionTitle'),
							type: "warning",
							showCancelButton: true,
							confirmButtonColor: "#DD6B55",
							confirmButtonText: getResource('app.delete'),
							cancelButtonText: getResource('app.cancel')
						},function() {
							// Show loader
							loaderIndicator(true);
							// API delete
							_api.deleteMessage_POST(success, error, getCookie(ACCESSTOKEN_COOKIE_NAME), outgoingMessage.id());
						});
					};
				}
			}
		}
		
		// functions
		/*////////////////////////////////////////////////////////////*/
		function init() {
			getOutgoingMessages();
		}
		
		function getOutgoingMessages() {
			var success = function success(data, textStatus, jqXHR) {
				var modelData = {};
				// Hide loader
				loaderIndicator(false);
				if (data.success == true) {
					modelData.outgoingMessages = data.content;
					ctOutgoingMessagesModel = ko.viewmodel.fromModel(modelData,options);
					$('*[data-ko-bind="ctOutgoingMessagesModel"]').each(function(index, obj) {
						ko.applyBindings(ctOutgoingMessagesModel, obj);
					});
				} else {
					sweetAlert(getResource('app.informationTitle'), handleServerErrorMessage(data.displayErrorMessage), "error");
				}
			};
			var error = function error(jqXHR, textStatus, errorThrown) {
				// Hide loader
				loaderIndicator(false);
				sweetAlert("Error", errorThrown, "error");
			};
			// Show loader
			loaderIndicator(true);
			_api.getOutgoingMessages_POST(success, error, getCookie(ACCESSTOKEN_COOKIE_NAME), true, 365);
		}
		
		_sortByTime = function(a, b) {
			return a.messageDate() + a.messageTime() > b.messageDate() + b.messageTime() ? -1 : 1;
		};
		
		// init
		/*////////////////////////////////////////////////////////////*/
		init();
		
	};
}(jQuery));